<!--Main-->
<template>
  <el-pagination
    class="zh-page-pagination"
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="pageRequest.page"
    :page-sizes="pageSizes"
    :page-size="pageRequest.limit"
    layout="total, sizes, prev, pager, next, jumper"
    :total="total"
  ></el-pagination>
</template>

<script>
export default {
  name: "Main",
  props: {
    total: "",
    pageRequest: {
      type: Object
    },
    btList: {
      type: Array
    },
    pageSizes: {
      type: Array,
      default: () => { return [10, 15, 20, 30, 50, 100] }
    }
  },
  data() {
    return {
      
    };
  },
  methods: {
    handleClick(event, data) {
      this.$emit("handleClick", event, data);
    },
    handleSizeChange(val) {
      const page = 1;
      this.pageRequest.limit = val;
      this.pageRequest.page = page;
      this.$emit("pageChange", this.pageRequest);
    },
    handleCurrentChange(val) {
      this.pageRequest.page = val;
      this.$emit("pageChange", this.pageRequest);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pagination.vue